// extracted by css-extract-rspack-plugin
export default {"previewSkeleton":"src-modules-desktop-modules-files-integration-components-PreviewPanel-PreviewSkeleton-PreviewSkeleton-module__previewSkeleton-u4rWv_","infoSkeleton":"src-modules-desktop-modules-files-integration-components-PreviewPanel-PreviewSkeleton-PreviewSkeleton-module__infoSkeleton-pA8ZhJ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"previewSkeleton\":\"src-modules-desktop-modules-files-integration-components-PreviewPanel-PreviewSkeleton-PreviewSkeleton-module__previewSkeleton-u4rWv_\",\"infoSkeleton\":\"src-modules-desktop-modules-files-integration-components-PreviewPanel-PreviewSkeleton-PreviewSkeleton-module__infoSkeleton-pA8ZhJ\"}";
        // 1793872698276
        var cssReload = require("../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  